import { allValues, Rights } from '../rights';

export const HOUSEKEEPING_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.GENERAL.READ.key,
  Rights.GENERAL.CALENDAR.READ.key,
  Rights.GENERAL.CALENDAR.WRITE.key,
  ...allValues(Rights.GENERAL.MESSAGES),
  Rights.LISTS.READ.key,
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
]);
